export default "__VITE_ASSET__Jy79Fopd__"